import Footer from "../Footer";
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import registationBanner from "../../asset/registation/registation.png";

const Form = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: "",
    whatsappNumber: "",
    city: "",
    email: "",
    consent: false,
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked });
    } else if (name === "whatsappNumber") {
      // For WhatsApp number, only allow digits
      const sanitized = value.replace(/\D/g, "").slice(0, 10);
      setFormData({ ...formData, [name]: sanitized });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    // Clear error on change
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }

    // Clear global message
    if (message) {
      setMessage("");
    }
  };

  // Validate form fields
  const validateForm = () => {
    const newErrors = {};

    // Full Name validation
    if (!formData.fullName.trim()) {
      newErrors.fullName = "Full Name is required";
    } else if (formData.fullName.trim().length < 2) {
      newErrors.fullName = "Full Name must be at least 2 characters";
    }

    // WhatsApp Number validation
    if (!formData.whatsappNumber.trim()) {
      newErrors.whatsappNumber = "WhatsApp Number is required";
    } else if (!/^[0-9]{10}$/.test(formData.whatsappNumber.trim())) {
      newErrors.whatsappNumber = "Enter a valid 10-digit number";
    }

    // Email validation (optional but must be valid if provided)
    if (formData.email && !/^\S+@\S+\.\S+$/.test(formData.email.trim())) {
      newErrors.email = "Enter a valid email address";
    }

    // Consent validation
    if (!formData.consent) {
      newErrors.consent =
        "Please accept the Privacy Policy and Terms & Conditions to continue";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    // Validate form
    if (!validateForm()) {
      setMessage("❌ Please fix the errors in the form");
      return;
    }

    setLoading(true);

    try {
      // Prepare submission data
      const submissionData = {
        fullName: formData.fullName.trim(),
        whatsappNumber: formData.whatsappNumber.trim(),
        city: formData.city?.trim() || "",
        email: formData.email?.trim().toLowerCase() || "",
        consent: formData.consent,
      };

      console.log("Submitting registration:", submissionData);

      // Make API request
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/revibeRegistration/register`,
        submissionData,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 15000, // 15 second timeout
        },
      );

      console.log("Registration response:", res.data);

      // Show success message
      setMessage("✅ " + res.data.message);

      // Reset form
      setFormData({
        fullName: "",
        whatsappNumber: "",
        city: "",
        email: "",
        consent: false,
      });
      setErrors({});

      // Redirect to thank you page
      setTimeout(() => {
        navigate("/revibe-thankyou");
      }, 1500);
    } catch (err) {
      console.error("Registration Error:", err);

      let errorMessage = "Something went wrong. Please try again.";

      if (err.response) {
        // Server responded with error
        errorMessage = err.response.data?.message || err.response.statusText;

        // Handle specific error cases
        if (err.response.status === 400) {
          if (err.response.data?.message?.toLowerCase().includes("required")) {
            errorMessage = "❌ Please fill all required fields";
          }
        } else if (err.response.status === 500) {
          errorMessage = "❌ Server error. Please try again in a moment.";
        }
      } else if (err.request) {
        // Request was made but no response received
        errorMessage =
          "❌ Network error. Please check your internet connection.";
      } else if (err.code === "ECONNABORTED") {
        // Timeout error
        errorMessage = "❌ Request timeout. Please try again.";
      } else {
        errorMessage = err.message;
      }

      setMessage(errorMessage);

      // Auto-clear error message after 10 seconds
      setTimeout(() => {
        setMessage("");
      }, 10000);
    } finally {
      setLoading(false);
    }
  };

  // Reset form
  const handleReset = () => {
    setFormData({ fullName: "", whatsappNumber: "", city: "", email: "", consent: false });
    setErrors({});
    setMessage("");
  };

  return (
    <div className="max-w-4xl mx-auto p-4 border rounded-xl shadow-md">
      {/* Banner Image */}
      <img
        src={registationBanner}
        alt="Weight Loss Workshop Banner"
        className="w-full max-w-4xl mx-auto rounded-xl shadow-xl transition-all duration-700"
      />

      {/* Main Heading */}
      <h2 className="text-center text-red-600 text-2xl md:text-3xl font-bold mt-6">
        Fill Your Details & Start Your Sustainable Weight Loss Journey
      </h2>

      {/* Benefits List */}
      <ul className="mt-4 text-lg space-y-2 text-gray-700">
        {/* <li>✅ Unlock Bonuses Worth ₹15,000</li> */}
        <li>✅ 90 Mins Live Workshop</li>
        <li>✅ Learn the secrets to losing 15 kgs in 3 months</li>
        {/* <li>✅ Guidance from a Happiness Mentor & Relationship Counselor</li> */}
         <li>✅ Daily Hand Holding till you achieve Target Weight </li>
        {/* <li>
          ✅ Hosted by NLP & Mindfulness Expert, Happiness Mentor & Relationship
          Counselor
        </li> */}
        <li>
          ✅ Hosted by - Swapnil Gautam - A Real Life Transformation &
          Neuroscience Expert
        </li>
      </ul>

      {/* Registration Form */}
      <div className="mt-8 bg-gray-50 p-6 rounded-xl shadow-inner">
        <h3 className="text-xl font-semibold mb-4 text-center">
          Swapnil Online Sessions
        </h3>

        {/* Status Message */}
        {/* {message && (
          <div
            className={`p-3 mb-4 rounded text-center font-semibold transition-all ${
              message.startsWith("✅")
                ? "bg-green-100 text-green-700 border border-green-300"
                : message.startsWith("⚠️")
                ? "bg-yellow-100 text-yellow-700 border border-yellow-300"
                : "bg-red-100 text-red-700 border border-red-300"
            }`}
          >
            {message}
          </div>
        )} */}

        {/* Form */}
        <form
          className="grid grid-cols-1 gap-4 md:grid-cols-2"
          onSubmit={handleSubmit}
          noValidate
        >
          {/* Full Name */}
          <div>
            <label className="block font-medium mb-1">
              Full Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              className={`w-full border px-4 py-2 rounded focus:outline-none focus:ring-2 transition-all ${
                errors.fullName
                  ? "border-red-500 focus:ring-red-300"
                  : "border-gray-300 focus:ring-blue-500"
              }`}
              placeholder="Enter your full name"
              disabled={loading}
              autoComplete="name"
            />
            {errors.fullName && (
              <p className="mt-1 text-sm text-red-600">{errors.fullName}</p>
            )}
          </div>

          {/* WhatsApp Number */}
          <div>
            <label className="block font-medium mb-1">
              WhatsApp Number <span className="text-red-500">*</span>
            </label>
            <input
              type="tel"
              name="whatsappNumber"
              value={formData.whatsappNumber}
              onChange={handleChange}
              className={`w-full border px-4 py-2 rounded focus:outline-none focus:ring-2 transition-all ${
                errors.whatsappNumber
                  ? "border-red-500 focus:ring-red-300"
                  : "border-gray-300 focus:ring-blue-500"
              }`}
              placeholder="10-digit number"
              maxLength="10"
              disabled={loading}
              autoComplete="tel"
            />
            {errors.whatsappNumber && (
              <p className="mt-1 text-sm text-red-600">
                {errors.whatsappNumber}
              </p>
            )}
          </div>

          {/* City */}
          <div>
            <label className="block font-medium mb-1">City</label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
              placeholder="Enter your city"
              disabled={loading}
              autoComplete="address-level2"
            />
          </div>

          {/* Email */}
          {/* <div>
            <label className="block font-medium mb-1">Email ID</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={`w-full border px-4 py-2 rounded focus:outline-none focus:ring-2 transition-all ${
                errors.email
                  ? "border-red-500 focus:ring-red-300"
                  : "border-gray-300 focus:ring-blue-500"
              }`}
              placeholder="example@email.com"
              disabled={loading}
              autoComplete="email"
            />
            {errors.email && (
              <p className="mt-1 text-sm text-red-600">{errors.email}</p>
            )}
          </div> */}

          {/* Consent */}
          <div className="md:col-span-2">
            <label className="flex items-start gap-3 text-sm text-gray-700 cursor-pointer">
              <input
                type="checkbox"
                name="consent"
                checked={formData.consent}
                onChange={handleChange}
                disabled={loading}
                className="mt-1 h-4 w-4 shrink-0 accent-[#003322]"
              />
              <span>
                I have read and agree to the{" "}
                <a
                  href="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline text-blue-600"
                >
                  Privacy Policy
                </a>{" "}
                and{" "}
                <a
                  href="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline text-blue-600"
                >
                  Terms &amp; Conditions
                </a>{" "}
                and I consent to receive registration confirmation, reminders
                and program updates on WhatsApp as per the Privacy Policy.
              </span>
            </label>
            {errors.consent && (
              <p className="mt-1 text-sm text-red-600">{errors.consent}</p>
            )}
          </div>

          {/* Submit Button */}
          <div className="md:col-span-2 mt-6">
            <button
              type="submit"
              disabled={loading}
              className={`
                w-full py-4 rounded-xl
                font-extrabold uppercase tracking-widest
                text-[#003322]
                transition-all duration-300 ease-out
                transform
                ${
                  loading
                    ? "bg-yellow-300 cursor-not-allowed opacity-70"
                    : `
                      bg-[#FFD21E]
                      hover:bg-black
                      hover:text-white
                      hover:scale-105
                      hover:shadow-2xl
                      hover:shadow-black/50
                      active:scale-95
                    `
                }
              `}
            >
              {loading ? (
                <span className="flex items-center justify-center gap-2">
                  <svg
                    className="animate-spin h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                  </svg>
                  Submitting...
                </span>
              ) : (
                "ENROL NOW!"
              )}
            </button>
          </div>

          {/* Required Fields Note */}
          <div className="md:col-span-2 text-center text-sm text-gray-500 mt-2">
            Fields marked with <span className="text-red-500">*</span> are
            required
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default Form;
